export interface Word {
  id: string;
  word: string;
  image: string;
  category: string;
  pronunciation?: string;
}

export const wordsData: Word[] = [
  // Animals
  { id: 'cat', word: 'Cat', image: '/images/animals_3.jpeg', category: 'animals' },
  { id: 'dog', word: 'Dog', image: '/images/animals_3.jpeg', category: 'animals' },
  { id: 'bird', word: 'Bird', image: '/images/animals_3.jpeg', category: 'animals' },
  { id: 'fish', word: 'Fish', image: '/images/animals_3.jpeg', category: 'animals' },
  { id: 'elephant', word: 'Elephant', image: '/images/animals_6.jpeg', category: 'animals' },
  { id: 'monkey', word: 'Monkey', image: '/images/animals_6.jpeg', category: 'animals' },
  
  // Fruits
  { id: 'apple', word: 'Apple', image: '/images/fruits_2.jpeg', category: 'fruits' },
  { id: 'banana', word: 'Banana', image: '/images/fruits_2.jpeg', category: 'fruits' },
  { id: 'orange', word: 'Orange', image: '/images/fruits_2.jpeg', category: 'fruits' },
  { id: 'strawberry', word: 'Strawberry', image: '/images/fruits_2.jpeg', category: 'fruits' },
  { id: 'grapes', word: 'Grapes', image: '/images/fruits_2.jpeg', category: 'fruits' },
  
  // Colors
  { id: 'red', word: 'Red', image: '/images/colors_3.jpeg', category: 'colors' },
  { id: 'blue', word: 'Blue', image: '/images/colors_3.jpeg', category: 'colors' },
  { id: 'green', word: 'Green', image: '/images/colors_3.jpeg', category: 'colors' },
  { id: 'yellow', word: 'Yellow', image: '/images/colors_3.jpeg', category: 'colors' },
  { id: 'purple', word: 'Purple', image: '/images/colors_3.jpeg', category: 'colors' },
  { id: 'orange_color', word: 'Orange', image: '/images/colors_3.jpeg', category: 'colors' },
  
  // Numbers
  { id: 'one', word: 'One', image: '/images/numbers_3.jpeg', category: 'numbers' },
  { id: 'two', word: 'Two', image: '/images/numbers_3.jpeg', category: 'numbers' },
  { id: 'three', word: 'Three', image: '/images/numbers_3.jpeg', category: 'numbers' },
  { id: 'four', word: 'Four', image: '/images/numbers_3.jpeg', category: 'numbers' },
  { id: 'five', word: 'Five', image: '/images/numbers_3.jpeg', category: 'numbers' },
];

export const categories = [
  {
    id: 'animals',
    name: 'Animals',
    icon: '🐾',
    color: 'hsl(var(--animals))',
    description: 'Learn about cute animals!'
  },
  {
    id: 'fruits',
    name: 'Fruits',
    icon: '🍎',
    color: 'hsl(var(--fruits))',
    description: 'Discover delicious fruits!'
  },
  {
    id: 'colors',
    name: 'Colors',
    icon: '🌈',
    color: 'hsl(var(--colors))',
    description: 'Explore beautiful colors!'
  },
  {
    id: 'numbers',
    name: 'Numbers',
    icon: '🔢',
    color: 'hsl(var(--numbers))',
    description: 'Count with fun numbers!'
  }
];